module.exports = __webpack_public_path__ + "img/company-features.d39e3b78.svg";